function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkeletonWithStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dmk399jhea"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(4 4)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h32v32H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -4)",
    style: {
      clipPath: "url(#dmk399jhea)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15565.517 77.933a1.3 1.3 0 0 1-1.484-1.457v-.985a1.306 1.306 0 0 1 1.484-1.446h8.533a1.3 1.3 0 0 1 1.473 1.446v.985a1.3 1.3 0 0 1-1.473 1.457zm12.721-.91a1.034 1.034 0 0 1-1.027-1.039 1.024 1.024 0 0 1 1.027-1.027h8.282a1.027 1.027 0 0 1 1.04 1.027 1.044 1.044 0 0 1-1.04 1.039zm-12.721-5.067a1.306 1.306 0 0 1-1.484-1.461v-.981a1.312 1.312 0 0 1 1.484-1.461h20.558a1.313 1.313 0 0 1 1.485 1.461v.981a1.306 1.306 0 0 1-1.485 1.461zm15.9-6.38-.445-1.946a2.4 2.4 0 0 0-1.81-1.809l-1.945-.441a.8.8 0 0 1-.621-.781.8.8 0 0 1 .621-.777l1.945-.445a2.392 2.392 0 0 0 1.81-1.8l.445-1.949a.8.8 0 0 1 .777-.621.8.8 0 0 1 .781.621l.441 1.949a2.392 2.392 0 0 0 1.809 1.8l1.946.445a.8.8 0 0 1 .625.777.8.8 0 0 1-.625.781l-1.946.441a2.4 2.4 0 0 0-1.809 1.809l-.441 1.946a.8.8 0 0 1-.781.625.8.8 0 0 1-.775-.625zm-16.358-.512a1.03 1.03 0 0 1-1.027-1.035 1.016 1.016 0 0 1 1.027-1.027h8.463a1.023 1.023 0 0 1 1.035 1.027 1.037 1.037 0 0 1-1.035 1.035z",
    transform: "translate(15575.117 -46.466)",
    style: {
      fill: "#1c1c1e"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkeletonWithStar);
export default __webpack_public_path__ + "static/media/skeleton-with-star.f0115f58.svg";
export { ForwardRef as ReactComponent };